<template>
    <b-container fluid>
        <b-row class="">
			<b-col cols="12" lg="12">
                <div class="d-flex justify-content-between align-items-end border-bottom pb-3">
                    <div class="">
                        <h3 class="">🎯평가관리</h3>
                        <p class="fw-400 text-secondary mb-0">프로젝트에 등록된 업체와 평가 진행 현황을 관리합니다. (미신청 업체 포함)</p>
                    </div>
                </div>
			</b-col>
		</b-row>
        <template v-if="is_initial_loading">
            <b-row class="admin-body-full-height mt-3">
                <b-col cols="12">
                    <div class="d-flex align-items-center justify-content-center bgray-200 h-100">
                        <b-spinner class="align-middle mr-3"></b-spinner>
                        <h3 class="mb-0">Loading...</h3>
                    </div>
                </b-col>
			</b-row>
        </template>
        <template v-else>
            <b-row class="my-4">
                <b-col cols="12">
                    <b-card>
                        <template #header>
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="mb-0">🔎평가 검색</h5>

                                <div>
                                    <b-btn variant="primary"
                                        class="mr-2"
                                        @click="searchAssessments"
                                        :disabled="is_gloabl_loading"
                                        >
                                        조회하기
                                    </b-btn>
                                    <b-btn variant="outline-secondary"
                                        @click="searchAssessments(true)"
                                        :disabled="is_gloabl_loading"
                                        >
                                        초기화
                                    </b-btn>
                                </div>
                            </div>
                        </template>
                        <div class="pl-3">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group
                                        id="fieldset-period"
                                        label="PERIOD"
                                        label-for="input-period"
                                        >
                                        <!-- <b-form-input id="input-project-code" v-model="filters.project_code" trim></b-form-input> -->
                                        <b-form-checkbox-group
                                            id="input-period"
                                            v-model="filters.periods"
                                            :options="periods"
                                            value-field="value"
                                            text-field="text"
                                            disabled-field="notEnabled"
                                            :disabled="is_gloabl_loading"
                                            @change="searchAssessments"
                                            >
                                        </b-form-checkbox-group>
                                        <b-btn size="sm" variant="outline-secondary" class="mt-1"
                                            :disabled="is_gloabl_loading"
                                            @click="selectAllPeriods">
                                            전체 기간
                                        </b-btn>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-project-code"
                                        label="프로젝트 코드"
                                        label-for="input-project-code"
                                        >
                                        <auto-complete-select
                                            v-model="selectedProjectId"
                                            :options="projectCodeOptions"
                                            option-value-key="id"
                                            placeholder="프로젝트 코드 선택 또는 검색"
                                            start-expanded
                                            clearable
                                            @input="onProjectCodeSelected"
                                            />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-assessment-type"
                                        label="평가유형"
                                        label-for="input-assessment-type"
                                        >
                                        <b-form-select id="input-assessment-type"
                                            v-model="filters.service_type"
                                            :disabled="is_gloabl_loading"
                                            @change="searchAssessments"
                                            >
                                            <option value="" selected>평가유형 선택</option>
                                            <option value="일반"> 일반</option>
                                            <option value="심화">심화</option>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-status"
                                        label="진행상태"
                                        label-for="input-status"
                                        >
                                        <b-form-select id="input-status" v-model="filters.status_code" :disabled="is_gloabl_loading" @change="searchAssessments">
                                            <option value="" selected>진행상태 선택</option>
                                            <option value="not_requested">미신청</option>
                                            <option value="requested"> 평가신청</option>
                                            <option value="in_progress">답변중</option>
                                            <option value="in_assessment">평가중</option>
                                            <option value="re_progress">재답변중</option>
                                            <option value="completed">평가완료</option>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-company-name"
                                        label="기업명"
                                        label-for="input-company-name"
                                        >
                                        <b-form-input id="input-company-name"
                                            v-model="filters.company_name"
                                            :disabled="is_gloabl_loading"
                                            trim
                                            @keypress.enter="searchAssessments"
                                            />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-request-username"
                                        label="신청인"
                                        label-for="input-request-username"
                                        >
                                        <b-form-input id="input-request-username"
                                            v-model="filters.user_name"
                                            :disabled="is_gloabl_loading"
                                            trim
                                            @keypress.enter="searchAssessments"
                                            />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-request-usermail"
                                        label="신청 이메일"
                                        label-for="input-request-usermail"
                                        >
                                        <b-form-input
                                            id="input-request-usermail"
                                            v-model="filters.e_mail"
                                            :disabled="is_gloabl_loading"
                                            trim
                                            @keypress.enter="searchAssessments"
                                            />
                                    </b-form-group>
                                </b-col>
                                
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="assessment-panel">
                <b-col cols="12" class="h-md-100 mb-3">
                    <b-card class="shadow-sm" no-body>
                        <template #header>
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="mb-0">🎯평가 관리 데이터</h5>
                                <div>
                                    현재 데이터 개수: {{ data_num }} 개
                                </div>
                            </div>
                        </template>
                        <div class="">
                            <b-table ref="assessmentTable"
                                id="assessment-table"
                                :items="assessments"
                                :fields="assessment_fields"
                                :per-page="assessment_perPage"
                                :current-page="assessment_currentPage"
                                class="mb-0"
                                show-empty
                                sticky-header="100vh"
                                thead-class="sticky-header-sort-fix"
                                sort-icon-left
                                empty-html="<h6 class='my-3 gray-400'>조회된 평가가 없습니다.</h6>"
                                :busy="is_loading_assessments"
                                >

                                <template #table-busy>
                                    <div class="d-flex align-items-center justify-content-center my-3">
                                        <b-spinner class="align-middle mr-2" style="width: 1.3rem; height: 1.3rem"></b-spinner>
                                        <strong>조회중...</strong>
                                    </div>
                                </template>

                                <template #cell(index)="data">
                                    {{ data.value + 1 }}
                                </template>

                                <template #cell(service_type)="data">
                                    <div :class="['f-95', service_type_variant[data.value], 'fw-500 rounded px-1 py-1']">
                                        {{  data.value }}
                                    </div>
                                </template>

                                <template #cell(company_name)="data">
                                    <div class="mb-2">
                                        {{ data.item.company_name }}
                                        <b-badge variant="light">
                                            {{ data.item.company_id }}
                                        </b-badge>
                                    </div>

                                    <div class="border border-color-gray-300 bgray-100 rounded">
                                        <div class="border-bottom border-color-gray-300 px-2 py-1">
                                            {{ data.item.user_name }}
                                            <b-badge variant=" bgray-300">
                                                {{ data.item.user_id }}
                                            </b-badge>
                                        </div>
                                        <div class="px-2 py-1">
                                            <p class="mb-0">
                                                {{ data.item.e_mail }}
                                            </p>
                                        </div>
                                    </div>
                                </template>

                                <template #cell(campaign_id)="data">
                                    <div v-if="data.item.campaign_id">
                                        {{ data.item.campaign_name }}
                                        <b-badge variant="light">
                                            {{ data.item.campaign_id }}
                                        </b-badge>
                                    </div>
                                    <div v-else>
                                        -
                                    </div>
                                </template>

                                <template #cell(requested_ts)="data">
                                    <div class="date-text">
                                        {{ data.item.requested_ts ? data.item.requested_ts : '-' }}
                                    </div>
                                </template>

                                <template #cell(duedate_ts)="data">
                                    <div class="date-text" :class="getDuedateVarient(data.item)">
                                        <b> {{ data.item.duedate_ts }} </b>
                                    </div>
                                </template>

                                <template #cell(in_assessment_ts)="data">
                                    <div class="date-text">
                                        {{ data.item.in_assessment_ts ? data.item.in_assessment_ts : '-' }}
                                    </div>
                                </template>

                                <template #cell(completed_ts)="data">
                                    <div class="date-text">
                                        {{ data.item.completed_ts ? data.item.completed_ts : '-' }}
                                    </div>
                                </template>

                                <template #cell(status_code)="data">
                                    <div v-if="data.item.status_code">
                                        <h6>
                                            <b-badge pill :variant="getStatusVarient(data.item)">
                                                {{ getKoreanStatus(data.item) }}
                                            </b-badge>
                                        </h6>
                                    </div>
                                </template>

                                <template #cell(status_change)="data">
                                    <b-button v-if="data.item.status_code == 'in_progress'"
                                        size="sm"
                                        variant="outline-secondary"
                                        :disabled="is_admin !== 4 || is_loading_submit_by_qesg"
                                        @click="submitAnswerByQesg(data.item)"
                                        >
                                        임의제출
                                    </b-button>
                                    <b-button v-if="data.item.status_code == 'in_assessment'"
                                        size="sm"
                                        variant="outline-primary"
                                        :disabled="is_admin !== 4 || is_loading_change_answer_mode"
                                        @click="backToInProgress(data.item)"
                                        >
                                        답변수정
                                    </b-button>
                                </template>

                                <template #cell(member)="data">
                                    <b-button size="sm" variant="dark-border"
                                        :disabled="is_loading_member_modal"
                                        @click.stop="openMemberModal(data.item)"
                                        >
                                        참여자
                                    </b-button>
                                </template>

                                <template #cell(admin)="data">
                                    <b-button size="sm" @click.stop="openCommentModal(data.item)">
                                        <fa icon="comment-dots"></fa>
                                    </b-button>
                                </template>
                            </b-table>
                        </div>
                    </b-card>
                </b-col>

                <b-col>
                    <div class="d-flex">
                        <div class="d-flex mx-auto">
                            <b-pagination
                                v-model="assessment_currentPage"
                                :total-rows="assessments.length"
                                :per-page="assessment_perPage"
                                :disabled="is_loading_assessments"
                                class="mr-2 mb-0"
                                aria-controls="assessment-table"
                            >
                            </b-pagination>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-modal id='comment-modal'
                title="기업 커뮤니케이션 로그"
                size="lg"
                hide-footer
                >
                <comm-log :comment_company="comment_info"></comm-log>
            </b-modal>

            <assessment-member-modal v-if="member_modal_company"
                ref="assessment-member-modal"
                :selected_company="member_modal_company"
                />
        </template>
    </b-container>
</template>
  
<script>
import CommLog from '@shared_components/admin/components/managing/CommLog.vue'
import AutoCompleteSelect from '@core/components/common/AutoCompleteSelect.vue'
import { getProjectCodeOptions } from './Management/common-data'
import AssessmentMemberModal from './Management/Company/_SubComponent/AssessmentMemberModal.vue'

export default {
    name: 'admin-assessment',
    components: {
        CommLog,
        AutoCompleteSelect,
        AssessmentMemberModal
    },
    data() {
        return {
            is_initial_loading: false,
            is_loading_assessments: false,
            is_loading_change_answer_mode: false,
            is_loading_submit_by_qesg: false,

            assessment_perPage: 50,
            assessment_currentPage: 1,

            assessments: [],
            periods: [],
            projects: [],
            selectedProjectId: null,
            data_num: 0,

            filters: {
                periods: [],
                project_code: null,
                service_type: null,
                status_code: null,
                company_name: null,
                user_name: null,
                e_mail: null
            },

            assessment_fields: [
                {
                    key: 'index',
                    label: '번호',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%;',
                    tdClass: 'text-center'
                },
                {
                    key: 'period',
                    label: 'PERIOD',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%; '
                },
                {
                    key: 'project_code',
                    label: '프로젝트코드',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%; '
                },
                {
                    key: 'service_type',
                    label: '평가유형',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%; ',
                    tdClass: 'text-center',
                },
                {
                    key: 'company_name',
                    label: '기업 및 신청인',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%; '
                },
                {
                    key: 'campaign_id',
                    label: '캠페인',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:25%; '
                },
                {
                    key: 'requested_ts',
                    label: '신청일  ',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:8%; '
                },
                {
                    key: 'duedate_ts',
                    label: '제출기한',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:8%; font-weight: bold; '
                },
                {
                    key: 'in_assessment_ts',
                    label: '평가시작',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:8%; '
                },
                {
                    key: 'completed_ts',
                    label: '완료일',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:8%; '
                },
                {
                    key: 'status_code',
                    label: '진행상태',
                    sortable: true,
                    thClass: 'mb-0',
                    tdClass: 'text-center',
                    thStyle: 'width:5%;'
                },
                {
                    key: 'status_change',
                    label: '상태변경',
                    sortable: true,
                    thClass: 'mb-0',
                    tdClass: 'text-center',
                    thStyle: 'width:5%;'
                },
                {
                    key: 'member',
                    label: '참여자',
                    sortable: false,
                    thClass: 'mb-0 text-center',
                    tdClass: 'text-center',
                    thStyle: 'width:4%;'
                },
                {
                    key: 'admin',
                    label: '히스토리',
                    sortable: false,
                    thClass: 'mb-0 text-center',
                    tdClass: 'text-center',
                    thStyle: 'width:3%;'
                },
            ],

            comment_info: null,

            // 평가 참여자 관리 모달 (기업 상세 화면과 같은 컴포넌트)
            member_modal_company: null,
            is_loading_member_modal: false,
            
            service_type_variant: {
                '일반': 'bgray-400',
                '심화': 'bg-red4'
            }

        }
    },
    computed: {
        is_admin() {
            return Number(this.$store.getters.isAdmin)
        },
        is_gloabl_loading () {
            return this.is_initial_loading || this.is_loading_assessments || this.is_loading_change_answer_mode || this.is_loading_submit_by_qesg
        },
        projectCodeOptions() {
            return getProjectCodeOptions(this.projects)
        }
    },
    async created() {
        this.is_initial_loading = true
        this.getProjectCodes()
        await this.getAllPeriods()
        if (this.hasQueryFilters()) {
            this.applyFiltersFromQuery()
            await this.searchAssessments()
        } else {
            await this.searchAssessments(true)
        }
        this.is_initial_loading = false
    },
    methods: {
        async getAllPeriods() {
            try {
                const response = await this.$axios.get('/assessments/periods')
                this.periods = response.data.reduce((_periods, _period) => {
                    _periods.push({ text: _period, value: _period })
                    return _periods
                }, []);
            } catch (error) {
                console.error('Error searching periods:', error);
            }
        },
        async getProjectCodes() {
            try {
                const response = await this.$axios.get('/project_code')
                this.projects = response.data
                this.syncSelectedProjectId()
            } catch (error) {
                console.error('Error loading project codes:', error);
            }
        },
        hasQueryFilters() {
            const q = this.$route.query || {}
            return ['periods', 'project_code', 'service_type', 'status_code', 'company_name', 'user_name', 'e_mail']
                .some(k => q[k] != null)
        },
        applyFiltersFromQuery() {
            const q = this.$route.query || {}
            this.filters = {
                periods: q.periods ? (Array.isArray(q.periods) ? q.periods : [q.periods]) : [],
                project_code: q.project_code || null,
                service_type: q.service_type || null,
                status_code: q.status_code || null,
                company_name: q.company_name || null,
                user_name: q.user_name || null,
                e_mail: q.e_mail || null
            }
            this.syncSelectedProjectId()
        },
        syncSelectedProjectId() {
            // filters.project_code 에 대응하는 프로젝트 id 를 찾아 드롭다운 선택 상태를 맞춘다.
            // projects 가 아직 로드 전이면 getProjectCodes 완료 후 다시 호출돼 맞춰진다.
            if (!this.filters.project_code) {
                this.selectedProjectId = null
                return
            }
            for (const group of this.projects) {
                const found = (group.projects || []).find(p => p.project_code === this.filters.project_code)
                if (found) { this.selectedProjectId = found.id; return }
            }
        },
        onProjectCodeSelected(projectId) {
            if (!projectId) {
                this.filters.project_code = null
            } else {
                let code = null
                for (const group of this.projects) {
                    const found = (group.projects || []).find(p => p.id === projectId)
                    if (found) { code = found.project_code; break }
                }
                this.filters.project_code = code
            }
            this.searchAssessments()
        },
        selectAllPeriods() {
            this.filters.periods = this.periods.map(_p => _p.value)
            this.searchAssessments()
        },
        async searchAssessments(isInitial = false) {
            try {
                this.is_loading_assessments = true
                this.assessment_currentPage = 1
                const _filters = {};

                if (isInitial === true) {
                    this.filters = {
                        periods: [],
                        project_code: null, service_type: null, status_code: null,
                        company_name: null, user_name: null, e_mail: null
                    }
                    this.selectedProjectId = null

                    if (this.periods.length) {
                        this.filters.periods.push(this.periods[0].value)
                    }
                }

                const {
                    periods, project_code, service_type, status_code, company_name, user_name, e_mail
                } = this.filters

                if (periods && periods.length) _filters.periods = periods
                if (project_code) _filters.project_code = project_code
                if (service_type) _filters.service_type = service_type
                if (status_code) _filters.status_code = status_code
                if (company_name) _filters.company_name = company_name
                if (user_name) _filters.user_name = user_name
                if (e_mail) _filters.e_mail = e_mail

                // 적용된 필터를 URL query params 에 반영 (공유/북마크/새로고침 복원용)
                this.$router.replace({ query: { ..._filters } }).catch(() => {})

                const response = await this.$axios.get('/assessments', {
                    params: { filters: _filters }
                })

                this.data_num = response.data.total_assessments
                this.assessments = response.data.list
                
                if (this.$refs.assessmentTable) {
                    this.$nextTick(() => {
                        this.$refs.assessmentTable.refresh()
                    })
                }
            } catch (error) {
                console.error('Error searching assessments:', error);
                this.$EventBus.$emit('toast-failure', '조회 실패', '평가 목록을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.')
            } finally {
                this.is_loading_assessments = false
            }
        },
        getStatusVarient({ status_code, in_assessment_ts }) {
            const status_code_variant_set = {
                'requested': 'success',
                'in_progress': 'secondary',
                'in_assessment': 'danger',
                're_progress': 'warning',
                'completed': 'dark',
                'canceled': 'light',
                'not_requested': 'light'
            }

            if (status_code_variant_set[status_code]) {
                if (status_code == 'in_progress' && in_assessment_ts) {
                    status_code_variant_set[status_code] = 'primary'
                }
                return status_code_variant_set[status_code]
            } else {
                return 'advance'
            }
        },
        getKoreanStatus({ status_code, in_assessment_ts }) {
            const status_code_kr_set = {
                'requested': '신청완료',
                'completed': '평가완료',
                'in_assessment': '평가 중',
                'in_progress': '보완요청',
                're_progress': '재답변중',
                'not_requested': '미신청',
            }

            if (status_code_kr_set[status_code]) {
                if (status_code == 'in_progress' && in_assessment_ts) {
                    status_code_kr_set[status_code] = '보완요청'
                }
                return status_code_kr_set[status_code]
            } else {
                return '평가취소'
            }
        },
        async submitAnswerByQesg(company) {
            try {
                this.is_loading_submit_by_qesg = true;
                const _confirm_force_submit = confirm('"'+company.company_name+'"의 답변을 임의 제출 하시겠습니까?')
                if (!_confirm_force_submit) {
                    return false
                }

                this.getDuedateVarient(company)

                if (this.$refs.assessmentTable) {
                    this.$nextTick(() => {
                        this.$refs.assessmentTable.refresh()
                    })
                }

                let _noti_force_submit = confirm('기업에게 평가 제출 안내 메일을 발송하시겠습니까?')
                const { campaign_id, company_id, project_code } = company
                await this.$axios.put('/company/submit', {
                    campaign_id, company_id, project_code,
                    is_force_sumit: true,
                    is_force_submit_noti: _noti_force_submit
                })
                alert(`${company.company_name}의 답변을 임의 제출 하였습니다.`)
                company.status_code = "in_assessment"
            } catch (error) {
                console.log(error)   
            } finally {
                this.is_loading_submit_by_qesg = false;
            }
        },
        async backToInProgress(company) {
            try {
                let _is_confirm_change_answer_mode = confirm('"' + company.company_name + '" 를 답변 가능한 상태로 변경하시겠습니까?')
                if (!_is_confirm_change_answer_mode) {
                    return false
                }

                this.is_loading_change_answer_mode = true

                this.getDuedateVarient(company)
                if (this.$refs.assessmentTable) {
                    this.$nextTick(() => {
                        this.$refs.assessmentTable.refresh()
                    })
                }

                const response = await this.$axios.put('/company/submit/cancel',
                    {
                        project_code: company.project_code,
                        company_id: company.company_id,
                        campaign_id: company.campaign_id
                    }
                )
                this.$EventBus.$emit('toast-success', '상태 변경 완료', `${company.company_name} (${response.data.company_id}) 를 답변 가능한 상태로 변환하였습니다.`)
                company.status_code = "in_progress"
            } catch (error) {
                if (error.response) {
                    const { status, data } = error.response
                    if (status === 404 && data.message === "Not_Found_Assessment_Request") {
                        this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company.company_name}의 평가신청 이력을 찾을 수 없습니다. 개발팀에 문의해주세요.`)
                    } else if (status === 400 && data.message === "Not_Status_Change") {
                        this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company.company_name} 가 답변 가능한 상태로 변경할 수 없는 상태입니다. 개발팀에 문의해주세요.`)
                    } else {
                        this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company.company_name} 를 답변 가능한 상태로 변환 중 장애가 발생했습니다. 개발팀에 문의해주세요.`)
                    }
                } else {
                    this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company.company_name} 를 답변 가능한 상태로 변환 중 장애가 발생했습니다. 개발팀에 문의해주세요.`)
                }
            } finally {
                this.is_loading_change_answer_mode = false
            }
        },
        getDuedateVarient(item) {
            let today = new Date()
            let duedate = new Date(item.duedate_ts)
            if (item.status_code === 'requested' || item.status_code === 'in_progress') {
                if (today.getTime() >= duedate.getTime()) {
                    item._cellVariants = { duedate_ts: 'danger' }
                } else {
                    let day_gap = duedate.getTime() - today.getTime()
                    let left_days = Math.floor(day_gap / (1000 * 60 * 60 * 24));
                    if (left_days <= 3) {
                        item._cellVariants = { duedate_ts: 'primary' }
                    }
                }
            }
        },
        async openMemberModal(item) {
            if (this.is_loading_member_modal) return
            try {
                this.is_loading_member_modal = true
                const { data } = await this.$axios.get(`/admin/company/${item.company_id}/info`)
                const { company, member, projects } = data
                const project = (projects || []).find(p => p.project_code === item.project_code
                    && (!item.campaign_id || Number(p.campaign_id) === Number(item.campaign_id)))
                if (!project) {
                    this.$EventBus.$emit('toast-failure', '평가 참여자 관리', `${item.company_name} 의 ${item.project_code} 평가 신청 건을 찾을 수 없습니다.`)
                    return
                }
                // 기업 상세 화면(CompanyManagementDetail.fetchDetailData)과 같은 모양으로 넘긴다.
                this.member_modal_company = {
                    company_id: item.company_id,
                    company_name: company.company_name,
                    member: member.map((m, index) => ({ ...m, index })),
                    projects
                }
                await this.$nextTick()
                await this.$refs['assessment-member-modal'].manageProjectMember(project)
            } catch (error) {
                console.error(error)
                this.$EventBus.$emit('toast-failure', '평가 참여자 관리', '기업 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.')
            } finally {
                this.is_loading_member_modal = false
            }
        },
        openCommentModal(company) {
            this.comment_info = company

            this.$nextTick(() => {
                this.$bvModal.show('comment-modal')
            })
        }
    }
}
</script>
  
<style lang="scss">
.small-text {
    font-size: 80% !important;
}

.date-text {
    font-size: 90% !important;
}
</style>